export default __webpack_public_path__ + "static/media/women14.878f9af1.jpg";